<template>
    <div >
        <el-radio-group v-model="timeType" @change="handleTimeTypeChange">
            <el-radio :label="TIME_TYPE.CUSTOM">自定义开始日期</el-radio>
            <el-radio :label="TIME_TYPE.DYNAMIC">动态当天</el-radio>
        </el-radio-group>
        <p class="mt10"/>
        <template v-if="!!formData.startTime">
            <el-date-picker
            v-model="formData.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerStartOptions"
            :clearable="false"
            :editable="false"
            placeholder="选择投放开始日期">
            </el-date-picker>
        </template>
        <template v-else><span style="color: #333;font-size:12px">动态当天开始日期</span></template>
        -
        <el-date-picker
            v-model="formData.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerEndOptions"
            clearable
            :editable="false"
            placeholder="选择投放结束日期">
        </el-date-picker>
        <div 
            v-if="timeType ===TIME_TYPE.DYNAMIC&&formData.endTime" 
            class="el-form-item__error form-item_tip"
        >
            建议不选择结束日期，否则可能会造成开始日期大于结束日期，导致创建失败
        </div>
    </div>
</template>
  
<script>
  
import _ from 'lodash'
import { parseTime } from '@/utils'
const TIME_TYPE = Object.freeze({
  CUSTOM: 1,
  DYNAMIC: 2
})
export default {
    name: 'DynamicDate',
    components: {
        
    },
    props: {
        value: {
            type: Array,
            default: ()=>[TIME_TYPE.DYNAMIC, '', '']
        }
    },
    data() {
        const [timeType = TIME_TYPE.DYNAMIC, startTime, endTime ] = this.value
        return {
            TIME_TYPE,
            timeType: timeType,
            formData: {
                startTime,
                endTime
            },
            pickerStartOptions: {
                disabledDate: (time)=> {
                    const end = this.formData.endTime
                    const start = time.getTime() < (Date.now()-24*60*60*1000)
                    if (end) {
                        return new Date(end).getTime()<time.getTime() || start;
                    }else {
                        return start
                    }
                }
            },
            pickerEndOptions: {
                disabledDate:(time)=>{
                    if (this.formData.startTime) {
                        return time.getTime() < new Date(this.formData.startTime).getTime()-24*60*60*1000;
                    }else {
                        return time.getTime() < (Date.now()-24*60*60*1000)
                    }
                }
            },
        }
    },
    computed: {
        timeData() {
            return [this.timeType, this.formData.startTime, this.formData.endTime]
        }
    },
    watch: {
        timeData: {
            handler(val) {
                this.$emit('input', val)
            },
            deep: true,
        },
    },
    methods: {
        handleTimeTypeChange(val) {
            if (TIME_TYPE.CUSTOM === val) {
                this.formData.startTime = parseTime(new Date(), '{y}-{m}-{d}')
            }else {
                this.formData.startTime = ''
            }
            this.formData.endTime = ''
        },
    }
}
</script>

<style scoped lang="scss">

</style> 